export const CART_SECTION_SELECTOR = "[data-cart-selector='cart-section']";
export const CART_EMPTY_SELECTOR = "[data-cart-selector='cart-empty']";
export const CART_ITEM_SELECTOR = "[data-cart-selector='cart-item']";
export const QUANTITY_INCREASE_SELECTOR =
  "[data-cart-selector='quantity-increase']";
export const QUANTITY_DECREASE_SELECTOR =
  "[data-cart-selector='quantity-decrease']";
export const QUANTITY_AMOUNT_SELECTOR =
  "[data-cart-selector='quantity-amount']";
export const QUANTITY_INVENTORY_AMOUNT_SELECTOR =
  "[data-cart-selector='quantity-inventory-amount']";
export const REMOVE_ITEM_SELECTOR = "[data-cart-selector='remove-item']";
export const ADD_SERVICE_SELECTOR = "[data-cart-selector='add-service']";
export const ADD_SERVICE_CONTAINER_SELECTOR =
  "[data-cart-selector='add-service-container']";
export const ADD_SERVICE_PRICE = "[data-cart-selector='service-price']";
export const ADD_SERVICE_IMAGE = "[data-cart-selector='service-image'] picture";
export const ITEM_MAX_PRICE_SELECTOR = "[data-cart-selector='item-max-price']";
export const ITEM_PRICE_SELECTOR = "[data-cart-selector='item-price']";
export const CART_SERVICE_ROW_TEXT = "[data-cart-selector='service-row-text']";

export const ADDED_SERVICE_SELECTOR = "[data-cart-selector='added-service']";
export const ADDED_SERVICE_PRICE_SELECTOR =
  "[data-cart-selector='added-service-price']";
export const FREE_SHIPPING_TITLE_SELECTOR =
  "[data-cart-selector='free-shipping-title']";
export const FREE_SHIPPING_PROGRESS_BAR_SELECTOR =
  "[data-cart-selector='free-shipping-progress-bar']";
export const FREE_SHIPPING_TRUE_SELECTOR =
  "[data-cart-selector='free-shipping-true']";
export const FREE_SHIPPING_FALSE_SELECTOR =
  "[data-cart-selector='free-shipping-false']";
export const FREE_SHIPPING_PROGRESS_PRICE_SELECTOR =
  "[data-cart-selector='free-shipping-progress-price']";

export const REMOVE_SERVICE_SELECTOR = "[data-cart-selector='remove-service']";

export const CART_SUMMARY_SELECTOR = "[data-cart-selector='cart-summary']";
export const CART_SUMMARY_LOADING_SELECTOR =
  "[data-cart-selector='cart-summary-loading']";
export const CART_SUMMARY_PRICE_SELECTOR =
  "[data-cart-selector='cart-summary-price']";
export const CART_DELIVERY_PRICE_SELECTOR =
  "[data-cart-selector='cart-delivery-price']";
export const CART_GOODS_PRICE_SELECTOR =
  "[data-cart-selector='cart-goods-price']";
export const CART_SUMMARY_SERVICES_SELECTOR =
  "[data-cart-selector='cart-summary-services']";

export const YIELD_TO_THE_FLOOR_SERVICE_SELECTOR =
  "[data-cart-selector='yield-to-the-floor-service']";

export const SERVICE_ROW_SELECTOR = "[data-cart-selector='service-row']";
export const SERVICE_ROW_PRICE_SELECTOR =
  "[data-cart-selector='service-row-price']";
export const SERVICE_ROW_IMAGE_SELECTOR =
  "[data-cart-selector='service-row-image'] img";
export const SERVICE_ROW_TITLE_SELECTOR =
  "[data-cart-selector='service-row-title']";

export const SERVICES_ITEMS_WRAPPER =
  '[data-cart-selector="services-items-wrapper"]';
export const YIELD_FLOOR_SELECT_SELECTOR =
  "[data-cart-selector='yield-floor-select']";
export const YIELD_LIMIT_SELECTOR = "[data-cart-selector='yield-limit']";
export const YIELD_CART_TOTAL_WO_YIELD_SELECTOR = "[data-cart-selector='cart_total_wo_yield']";
export const YIELD_INFO_SELECTOR = "[data-cart-selector='yield-info']";

export const CART_COUPON_INPUT_CONTAINER =
  "[data-cart-selector='cart-coupon-input-container']";
export const COUPON_SHOW_CHECKBOX_SELECTOR =
  '[data-cart-selector="coupon-show-checkbox"]';

export const COUPON_INPUT_SELECTOR = '[data-cart-selector="coupon-input"]';
export const COUPON_INPUT_CONTAINER_SELECTOR =
  '[data-cart-selector="coupon-input-container"]';

export const COUPON_ADDED_CONTAINER_SELECTOR =
  '[data-cart-selector="cart-coupon-added-container"]';
export const COUPON_CODE_SELECTOR = '[data-cart-selector="cart-coupon-code"]';
export const COUPON_VALUE_SELECTOR = '[data-cart-selector="cart-coupon-value"]';
export const COUPON_REMOVE_SELECTOR =
  '[data-cart-selector="cart-coupon-remove"]';
export const COUPON_CHECKBOX_CONTAINER_SELECTOR =
  '[data-cart-selector="cart-checkbox-container"]';
export const COUPON_ADD_SELECTOR = '[data-cart-selector="coupon-add"]';
export const CART_NOTE = '[data-cart-note]';
export const CART_NOTE_TOGGLER = '[data-cart-note-toggler]';
export const CHECKOUT_BUTTON_SELECTOR = '[data-checkout-submit]';
export const STICKY_CHECKOUT_SELECTOR = '[data-sticky-checkout-container]';
export const STICKY_CHECKOUT_BUTTON_SELECTOR = '[data-sticky-checkout-button]';
export const ATC_BUTTON_SELECTOR = '[data-atc-button]';
export const STICKY_ATC_CONTAINER_SELECTOR = '[data-sticky-atc-container]';
export const STICKY_ATC_BUTTON_SELECTOR = '[data-sticky-atc-button]';


export const getItemQuantitySelector = (id) =>
  `[data-cart-selector='item-quantity'][data-id='${id}']`;

export const getAddedServiceSelector = (handle) =>
  `[data-cart-selector='added-service'][data-handle='${handle}']`;

export const getAddServiceContainerSelector = (handle) =>
  `${ADD_SERVICE_CONTAINER_SELECTOR}[data-handle='${handle}']`;

export const getRemoveAddedServiceSelector = (handle) =>
  `${getAddedServiceSelector(handle)} ${REMOVE_SERVICE_SELECTOR}`;

export const getServiceRowSelector = (handle) =>
  `${SERVICE_ROW_SELECTOR}[data-handle='${handle}']`;

export const getServiceRowPriceSelector = (handle) =>
  `${SERVICE_ROW_SELECTOR}[data-handle='${handle}'] ${SERVICE_ROW_PRICE_SELECTOR}`;
